import { render, staticRenderFns } from "./ClientTaskForm.vue?vue&type=template&id=0c842770&scoped=true&"
import script from "./ClientTaskForm.vue?vue&type=script&lang=js&"
export * from "./ClientTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c842770",
  null
  
)

export default component.exports